import ProductsService from 'src/features/products/data/service/ProductsService';
import {
  ProductsListingParams,
  ProductsRepositoryInterface,
  SearchProductsByTagParams,
  StoreStock,
  StoreStockByCategoryParams,
  StoreStockBySubcategoryParams,
  StoreStockParams,
} from '../domain/ProductsRepositoryInterface';
import { injectable, inject } from 'inversify';
import { GetProductDetailParams } from 'src/features/products/data/service/ProductsService.types';
import { getStorageSession } from 'src/utils/localStorage/session';

@injectable()
class ProductsRepository implements ProductsRepositoryInterface {
  @inject(ProductsService) private productsService!: ProductsService;

  async getStoreStock({
    search,
    ...params
  }: StoreStockParams): Promise<StoreStock> {
    const session = JSON.parse(window.localStorage.getItem('session') ?? '{}');
    const isB2b = session?.user?.type === 'b2b';
    const serializedSearch = search?.replace(/\+/g, ' ');
    const response = await this.productsService.getStoreStock({
      ...params,
      ...(serializedSearch && { search: serializedSearch }),
    });

    if (isB2b) {
      const b2bResponse = response.data.results.map((product) => {
        return {
          ...product,
          price: product.b2b_price ? product.b2b_price : product.price,
        };
      });

      return {
        ...response.data,
        results: b2bResponse,
      };
    }

    return response.data;
  }

  async getStoreStockByCategory(params: StoreStockByCategoryParams) {
    const session = JSON.parse(window.localStorage.getItem('session') ?? '{}');
    const isB2b = session?.user?.type === 'b2b';
    const response = await this.productsService.getStoreStock(params);

    if (isB2b) {
      const b2bResponse = response.data.results.map((product) => {
        return {
          ...product,
          price: product.b2b_price ? product.b2b_price : product.price,
        };
      });

      return {
        ...response.data,
        results: b2bResponse,
      };
    }

    return response.data;
  }

  async getStoreStockBySubCategory(params: StoreStockBySubcategoryParams) {
    const response = await this.productsService.getSubcategoryStock(params);

    return response.data;
  }

  async getProductsListing(params: ProductsListingParams) {
    const response = await this.productsService.getProductsListing(params);

    return response.data;
  }

  async getProductDetail(params: GetProductDetailParams) {
    const response = await this.productsService.getProductDetail(params);

    return response.data;
  }

  async searchProductsByTag({
    tagSearch,
    storeSlug,
  }: SearchProductsByTagParams) {
    const session = getStorageSession();
    const isB2b = session?.user?.type === 'b2b';
    const serializedTagSearch = tagSearch?.replace(/\+/g, ' ');
    const response = await this.productsService.getProductsByTag({
      token: session?.accessToken,
      tagSearch: serializedTagSearch,
      storeSlug,
    });

    if (isB2b) {
      const b2bResponse = response.data.results.map((product) => {
        return {
          ...product,
          price: product.b2b_price ? product.b2b_price : product.price,
        };
      });

      return {
        ...response.data,
        results: b2bResponse,
      };
    }

    return response.data;
  }
}

export default ProductsRepository;
